import { axios } from '@/lib/axios';
import { ModelID } from '@/types';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ActivityType, featurePath } from '.';

export type RecordActivityDTO = {
  assignmentId: ModelID;
  type: ActivityType;
};

// 204 No Content -- calling axios directly keeps the empty-body path
// symmetrical with the other command hooks that have no envelope to unwrap
// (see sendHeartbeat.ts), rather than mixing in the @/utils/api post() helper
// for just this one call.
export const postActivity = async (assignmentId: ModelID, type: ActivityType): Promise<void> => {
  await axios.post(`${featurePath}/${assignmentId}/activity`, { type }, { skipErrorToast: true });
};

// No invalidation, no toasts: a later task flips a "moved away" banner off a
// 409 from this hook, so the rejection must propagate to the caller
// untouched.
export const useRecordActivity = () => {
  return useMutation<void, AxiosError, RecordActivityDTO>({
    mutationFn: ({ assignmentId, type }) => postActivity(assignmentId, type),
  });
};
